import { render, staticRenderFns } from "./textUploadMore.vue?vue&type=template&id=35ad7e2e&scoped=true"
import script from "./textUploadMore.vue?vue&type=script&lang=js"
export * from "./textUploadMore.vue?vue&type=script&lang=js"
import style0 from "./textUploadMore.vue?vue&type=style&index=0&id=35ad7e2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ad7e2e",
  null
  
)

export default component.exports